import React from 'react';
import { makeStyles, TextField, Typography } from '@material-ui/core';
import i18n from 'i18n-js';

import { theme } from 'config/theme';
import { useTableMapWizard } from '../context';

const useStyles = makeStyles({
    root: {
        padding: '32px 40px',
    },
    heading: {
        fontSize: 16,
        fontWeight: 600,
        color: theme.palette.text.primary,
        marginBottom: 24,
    },
    field: {
        marginBottom: 24,
        width: '100%',
        maxWidth: 480,
    },
});

export default function BasicInformationStep() {
    const classes = useStyles();
    const { draft, dispatch } = useTableMapWizard();

    function handleNameChange(e: React.ChangeEvent<HTMLInputElement>) {
        dispatch({ type: 'SET_NAME', payload: e.target.value });
    }

    return (
        <div className={classes.root}>
            <Typography className={classes.heading}>
                {i18n.t('tableMaps.wizard.basicInformation')}
            </Typography>

            <div className={classes.field}>
                <TextField
                    label={i18n.t('tableMaps.wizard.tableMapName')}
                    value={draft.name}
                    onChange={handleNameChange}
                    variant="filled"
                    fullWidth
                    required
                    inputProps={{ 'aria-label': i18n.t('tableMaps.wizard.tableMapName') }}
                />
            </div>
        </div>
    );
}
